import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { style: {"padding-left":"20px"} }
const _hoisted_2 = { style: {"padding-left":"20px"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "n-radio",
  style: {"font-size":"16px"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: /*#__PURE__*/_normalizeClass({ 'n-radio__dot': true })
  })
], -1)

import {
  withDefaults,
  watchSyncEffect,
  ref,
  watch,
} from "vue";
import {
  NCollapse,
  NCollapseItem,
  NGrid,
  NGi,
  NRadio,
  NDivider,
  useMessage,
} from "naive-ui";
import AppTypeCard from "../appTypeCard/index.vue";
import type { ModuleType, Dependency, SelectedModels } from "./type";

export default /*#__PURE__*/_defineComponent({
  props: {
    data: { default: () => [] },
    artifactId: { default: "" },
    value: null
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
  (e: "change", value: SelectedModels): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { data: ModuleType[], artifactId: string, value: SelectedModels }

const message = useMessage();




let selectedModels = ref<SelectedModels>(props.value);

const handleCheckModel = (
  subModuleName: string,
  dependency: Dependency,
  subModule?: ModuleType
) => {
  console.log(subModuleName, dependency, subModule);
  if (!selectedModels.value[subModuleName]) {
    selectedModels.value[subModuleName] = {
      dependencyModels: [dependency],
      packaging: subModule?.packagingTypes,
    };
    emit("change", selectedModels.value);
    return true;
  }
  const _dependencyModels =
    selectedModels.value[subModuleName].dependencyModels;
  if (!haveSelectDependency(_dependencyModels, dependency)) {
    _dependencyModels.push(dependency);
    emit("change", selectedModels.value);
    return true;
  }
  selectedModels.value[subModuleName].dependencyModels =
    _dependencyModels.filter(
      (_dep) => _dep.artifactId !== dependency.artifactId
    );
  emit("change", selectedModels.value);
  return true;
};
const haveSelectDependency = (
  dependencyModels: Dependency[],
  dependency: Dependency
): boolean => {
  return (
    dependencyModels.filter(
      (_dependency) => _dependency.artifactId === dependency.artifactId
    ).length > 0
  );
};

const defaultSelect = () => {
  message.info("默认选择，无法取消");
};

// 寻找默认选择的 models
const setDefaultSelectedModels = (data: ModuleType[]) => {
  console.log(data);
  selectedModels.value = {};
  data.map((projectModule) => {
    projectModule.dependencys.map((dependency) => {
      if (!dependency.optional) {
        handleCheckModel("parent", dependency, projectModule);
      }
    });
    projectModule.subModules.map((subModule) => {
      subModule.dependencys.map((dependency) => {
        if (!dependency.optional) {
          handleCheckModel(subModule.subModuleName, dependency, subModule);
        }
      });
    });
  });
};
watch(
  () => props.data,
  (data) => {
    setDefaultSelectedModels(data);
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NCollapse), { "default-expanded-names": ['1'] }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, (projectModule) => {
        return (_openBlock(), _createBlock(_unref(NCollapseItem), {
          name: "1",
          key: projectModule.subModuleName || __props.artifactId,
          title: projectModule.subModuleName || __props.artifactId
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(NGrid), {
                cols: "3",
                "x-gap": "8",
                "y-gap": "8"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectModule.dependencys, (dependency) => {
                    return (_openBlock(), _createBlock(_unref(NGi), {
                      key: dependency.artifactId
                    }, {
                      default: _withCtx(() => [
                        _createVNode(AppTypeCard, {
                          title: dependency.display,
                          desc: dependency.desc
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NRadio), {
                              checked: 
                  _unref(selectedModels).parent &&
                  haveSelectDependency(
                    _unref(selectedModels).parent.dependencyModels,
                    dependency
                  )
                ,
                              onClick: ($event: any) => (
                  !dependency.optional
                    ? defaultSelect()
                    : handleCheckModel('parent', dependency, projectModule)
                )
                            }, null, 8, ["checked", "onClick"])
                          ]),
                          _: 2
                        }, 1032, ["title", "desc"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 2
              }, 1024)
            ]),
            _createVNode(_unref(NDivider)),
            _createVNode(_unref(NCollapse), null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectModule.subModules, (subModule) => {
                  return (_openBlock(), _createBlock(_unref(NCollapseItem), {
                    key: subModule.subModuleName,
                    title: __props.artifactId + '-' + subModule.subModuleName
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_unref(NGrid), {
                          cols: "3",
                          "x-gap": "8",
                          "y-gap": "8"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subModule.dependencys, (dependency) => {
                              return (_openBlock(), _createBlock(_unref(NGi), {
                                key: dependency.artifactId
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(AppTypeCard, {
                                    title: dependency.display,
                                    desc: dependency.desc,
                                    "min-height": 80
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_3,
                                      _createVNode(_unref(NRadio), {
                                        checked: 
                      _unref(selectedModels)[subModule.subModuleName] &&
                      haveSelectDependency(
                        _unref(selectedModels)[subModule.subModuleName]
                          .dependencyModels,
                        dependency
                      )
                    ,
                                        onClick: ($event: any) => (
                      !dependency.optional
                        ? defaultSelect()
                        : handleCheckModel(
                            subModule.subModuleName,
                            dependency,
                            subModule
                          )
                    )
                                      }, null, 8, ["checked", "onClick"])
                                    ]),
                                    _: 2
                                  }, 1032, ["title", "desc"])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["title"]))
                }), 128))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["title"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})